export const deserializeDate = (dateString) => {
  if (!dateString) {
    return;
  }
  return new Date(dateString.replace("T", " ") + " UTC");
};

export const timeSince = (date) => {
  if (!date) {
    return;
  }
  if (typeof date !== "object") {
    date = new Date(date);
  }
  var seconds = Math.floor((new Date() - date) / 1000);
  return timeSinceSeconds(seconds);
};

export const timeSinceSeconds = (seconds) => {
  var intervalType;
  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    intervalType = "year";
  } else {
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      intervalType = "month";
    } else {
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) {
        intervalType = "day";
      } else {
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
          intervalType = "hour";
        } else {
          interval = Math.floor(seconds / 60);
          if (interval >= 1) {
            intervalType = "min";
          } else {
            interval = seconds;
            intervalType = "sec";
          }
        }
      }
    }
  }
  if (interval > 1 || interval === 0) {
    intervalType += "s";
  }
  return interval + " " + intervalType;
};
